import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface TemplateType {
  id: string;
  name: string;
  account_id?: string;
  description?: string;
  body: string;
  visibility: "public" | "did" | "user" | "private";
  created_by?: string;
  dids?: string[];
  users?: string[];
  private_owner_id?: string | null;
}

export interface TemplateState {
  data: TemplateType[];
}

export const initialState: TemplateState = {
  data: [],
};

const templateSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {
    setTemplates: (state, action: PayloadAction<TemplateType[]>) => {
      state.data = action.payload;
    },
    addTemplateSlice: (state, action: PayloadAction<TemplateType>) => {
      state.data.push(action.payload);
    },

    deleteTemplateSlice: (state, action: PayloadAction<string>) => {
      const index = state.data.findIndex(
        (item) => item.id === action.payload
      );
      if (index !== -1) {
        state.data.splice(index, 1);
      }
    },

    updateTemplateSlice: (state, action: PayloadAction<TemplateType>) => {
      const index = state.data.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
  },
});

export const { setTemplates, updateTemplateSlice, addTemplateSlice, deleteTemplateSlice } = templateSlice.actions;

export default templateSlice.reducer;